import { render, staticRenderFns } from "./BalancesPlans.vue?vue&type=template&id=1564e0f6&"
import script from "./BalancesPlans.vue?vue&type=script&lang=js&"
export * from "./BalancesPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports